
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M32.589 8.533c-5.113 0-8.589 3.436-8.589 3.436s-3.457-3.436-8.589-3.436c-5.692 0-10.307 4.615-10.307 10.307C5.104 29.147 24 39.454 24 39.454S42.896 29.147 42.896 18.84c0-5.693-4.614-10.307-10.307-10.307z"}})])
          )
        }
      }
    